import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M849.972557 0.0110255483L849.972557 1497.94201 486.901252 1134.87071 331 1290.77196 960.228039 1920 1589.45608 1290.77196 1433.55483 1134.87071 1070.48352 1497.94201 1070.48352 0.0110255483z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconArrowDownSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconArrowDownSolid, _Component);

  var _super = _createSuper(IconArrowDownSolid);

  function IconArrowDownSolid() {
    _classCallCheck(this, IconArrowDownSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconArrowDownSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconArrowDown",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconArrowDownSolid.displayName = "IconArrowDownSolid";
  return IconArrowDownSolid;
}(Component);

IconArrowDownSolid.glyphName = 'arrow-down';
IconArrowDownSolid.variant = 'Solid';
IconArrowDownSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconArrowDownSolid;
export { IconArrowDownSolid };